import React from "react";

const Roadmap = () => {
  return (
    <div id="road-map" style={{overflow:"hidden"}}>

    <div id="roadmap" className=" position-relative roadmap pt-5 mt-5">
        <div className="row justify-content-center align-items-center ">
          
       
       <div className="main-roads mb-5">
       <h2 className=" text-center">Roadmap</h2>
      <div className="container px-0 pt-5 pb-5 feature">

          <div className="mx-auto main-road px-3  position-relative" style={{paddingTop:"80px !important"}}>
            <div className="timeline">
              <div className="d-flex align-items-center gap-4  timeline-item ">
                <div className="connector">
                  <div className="marker"></div>
                  <div className="year ">
                    <div className="inner-year">Q3 2024</div>
                  </div>
                </div>
                <div className="content"  data-aos="fade-left"
              data-aos-duration="1000">
                  <h3>Foundation and Community Building</h3>

                  <ul>
                    <li>
                      <p>Platform Launch</p>
                    </li>
                    <li>
                      <p>PHARMA Token Release</p>
                    </li>
                    {/* <li>
                      <p>Testnet Launch</p>
                    </li>
                    <li>
                      <p>Initial Staking and Delegation Setup</p>
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-center  gap-4 timeline-item  ">
                <div className="connector">
                  <div className="marker"></div>
                  <div className="year ">
                    <div className="inner-year">Q4 2024</div>
                  </div>
                </div>
                <div className="content-right"  data-aos="fade-right"
              data-aos-duration="1000">
                  <h3>Mainnet and Second Token Launch</h3>
                  <ul>
                    <li>
                      <p>Governance Implementation</p>
                    </li>
                    <li>
                      <p>Mobile App Development Begins</p>
                    </li>
                    {/* <li>
                      <p> CEX Listing (INFI and NET)</p>
                    </li>
                    <li>
                      <p>Initial Coverage Expansion</p>
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-start  gap-4 timeline-item ">
                <div className="connector">
                  <div className="marker"></div>
                  <div className="year">
                    <div className="inner-year">Q1 2025</div>
                  </div>
                </div>
                <div className="content" data-aos="fade-left"
              data-aos-duration="1000">
                  <h3>5G Integration and Ecosystem Growth</h3>
                  <ul>
                    <li>
                      <p>Staking Rewards Introduced</p>
                    </li>
                    <li>
                      <p>Support for Additional Blockchains</p>
                    </li>
                    {/* <li>
                      <p>Decentralized Marketplace Launch</p>
                    </li>
                    <li>
                      <p>Partnerships and Collaborations</p>
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-start  gap-4 timeline-item ">
                <div className="connector">
                  <div className="marker"></div>
                  <div className="year">
                    <div className="inner-year">2025 Q2-Q4</div>
                  </div>
                </div>
                <div className="content-right"  data-aos="fade-right"
              data-aos-duration="1000">
                  <h3>Network Scaling and Global Expansion</h3>
                  <ul>
                    <li>
                      <p>Advanced Analytics Tools Released</p>
                    </li>
                    <li>
                      <p>Community Expansion Initiatives</p>
                    </li>
                    {/* <li>
                      <p>5G Network Expansion</p>
                    </li>
                    <li>
                      <p>Sustainability Initiatives</p>
                    </li>
                    <li>
                      <p>DAO and Governance Implementation</p>
                    </li> */}
                  </ul>
                </div>
              </div>
            
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    </div>

  );
};

export default Roadmap;
